import api from './api'

export const customizationApi = {
  getCurrent: async () => {
    const response = await api.get('/customization/current')
    return response.data
  },

  updateLogo: async ({ logoUrl, logoBase64 }) => {
    const response = await api.put('/customization/logo', { logoUrl, logoBase64 })
    return response.data
  },

  updateLogoMenuBackdrop: async ({ mode, color }) => {
    const response = await api.put('/customization/logo-menu-backdrop', { mode, color })
    return response.data
  },

  updateFavicon: async ({ faviconUrl, faviconBase64 }) => {
    const response = await api.put('/customization/favicon', { faviconUrl, faviconBase64 })
    return response.data
  },

  createScheme: async ({ name, configJson, setAsDefault = false }) => {
    const response = await api.post('/customization/schemes', { name, configJson, setAsDefault })
    return response.data
  },

  setTenantDefault: async (schemeId) => {
    await api.put(`/customization/schemes/${schemeId}/tenant-default`)
  },

  setMyTheme: async (schemeId) => {
    await api.put('/customization/my-theme', { schemeId })
  },

  updateScheme: async (schemeId, { name, configJson }) => {
    const body = {}
    if (name != null) body.name = name
    if (configJson != null) body.configJson = configJson
    const response = await api.put(`/customization/schemes/${schemeId}`, body)
    return response.data
  },
}

